import axiosInstance from '../axiosInstance';
import { getManagerRoutePath } from '../managerRouteUtil';

/**
 * Training service — /api/carehome-manager/training.
 */
const trainingService = {
  // Board: training catalogue + every staff member with their assignments.
  getBoard: async () => {
    const routePath = getManagerRoutePath();
    const response = await axiosInstance.get(`/${routePath}/training`);
    return response.data;
  },

  // Create a training course.
  createTraining: async (payload) => {
    const routePath = getManagerRoutePath();
    const response = await axiosInstance.post(`/${routePath}/training/trainings`, payload);
    return response.data;
  },

  // Assign a training to one or more staff. Payload: { training_id, user_ids, due_date? }
  assign: async (payload) => {
    const routePath = getManagerRoutePath();
    const response = await axiosInstance.post(`/${routePath}/training/assign`, payload);
    return response.data;
  },

  // Manager override of an assignment's status, optionally attaching a proof
  // file (image/PDF). Sends multipart when a file is provided, else JSON.
  updateStatus: async (assignmentId, status, file = null) => {
    const routePath = getManagerRoutePath();
    const url = `/${routePath}/training/assignments/${assignmentId}/status`;
    if (file) {
      const fd = new FormData();
      fd.append('status', status);
      fd.append('proof', file);
      const response = await axiosInstance.patch(url, fd, { headers: { 'Content-Type': 'multipart/form-data' } });
      return response.data;
    }
    const response = await axiosInstance.patch(url, { status });
    return response.data;
  },

  // Un-assign a training from a staff member.
  unassign: async (assignmentId) => {
    const routePath = getManagerRoutePath();
    const response = await axiosInstance.delete(`/${routePath}/training/assignments/${assignmentId}`);
    return response.data;
  },
};

export default trainingService;
